module.exports = __webpack_public_path__ + "img/11.dfa2ece6.jpg";